import styled from "styled-components";

export const DetailPageTopBarElement = styled.div`
  align-items: center;
  background-color: var(--CLOUD, #fcfdfe);
  border-bottom: 1px solid var(--Color-Tokens-Border-Primary, #e4e4e4);
  box-sizing: border-box;
  display: flex;
  /* Keep the bar at full height when a tall sibling form overflows a flex column. */
  flex-shrink: 0;
  height: 72px;
  justify-content: space-between;
  min-height: 72px;
  padding: 0 24px;
`;

export const DetailPageTopBarLeftElement = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  min-width: 0;
`;

export const DetailPageTopBarAccentDividerElement = styled.div`
  align-self: stretch;
  background-color: var(--BLUE, #2060ea);
  flex-shrink: 0;
  width: 2px;
`;

export const DetailPageTopBarTitleBlockElement = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  min-width: 0;
`;

export const DetailPageTopBarTitleRowElement = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const DetailPageTopBarBreadcrumbElement = styled.div`
  color: var(--SLATE, #5c6679);
  font-family: Inter, sans-serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 14px;
  text-transform: uppercase;

  span {
    color: var(--Color-Tokens-Border-Primary, #c5cad3);
    margin: 0 6px;
  }
`;

export const DetailPageTopBarRightElement = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;
